import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d98b2744"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 0,
  class: "frisbuy-marketplace-reviews__product-raiting"
}
const _hoisted_3 = { class: "frisbuy-product-rating" }
const _hoisted_4 = { class: "frisbuy-product-rating__wrapper" }
const _hoisted_5 = { class: "frisbuy-product-rating__info" }
const _hoisted_6 = {
  key: 0,
  class: "frisbuy-product-rating__stars"
}
const _hoisted_7 = { class: "frisbuy-product-rating__counts" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Оставить отзыв", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["disabled", "aria-busy"]
const _hoisted_11 = {
  key: 0,
  class: "frisbuy-image-all-reviews-button__loader",
  "aria-hidden": "true"
}
const _hoisted_12 = { class: "frisbuy-marketplace-reviews__reviews-wrapper" }
const _hoisted_13 = { class: "frisbuy-marketplace-reviews__customers-photos" }
const _hoisted_14 = { class: "frisbuy-product-rating__mobile-rating-text" }
const _hoisted_15 = { class: "frisbuy-product-rating__mobile-counts" }
const _hoisted_16 = {
  key: 0,
  class: "frisbuy-marketplace-reviews__customers-photos-scroll-container"
}
const _hoisted_17 = { class: "frisbuy-marketplace-reviews__customers-photos-list" }
const _hoisted_18 = {
  key: 0,
  class: "frisbuy-marketplace-reviews__summary-section"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "frisbuy-marketplace-reviews__summary-description" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "frisbuy-marketplace-reviews__summary-title" }, " Что говорят люди "),
  /*#__PURE__*/_createElementVNode("span", { class: "frisbuy-marketplace-reviews__summary-subtitle" }, " собирательный отзыв на основе пользовательских мнений ")
], -1))
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "frisbuy-marketplace-reviews__customers-reviews" }
const _hoisted_22 = {
  key: 0,
  class: "frisbuy-marketplace-reviews__filter frisbuy-marketplace-reviews--min-full"
}
const _hoisted_23 = {
  key: 1,
  class: "frisbuy-marketplace-reviews__filter frisbuy-marketplace-reviews__filter--auto"
}
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "frisbuy-marketplace-reviews__filter frisbuy-marketplace-reviews__filter--auto" }
const _hoisted_26 = {
  key: 1,
  class: "frisbuy-marketplace-reviews__list"
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 2,
  class: "frisbuy-marketplace-reviews-not-found-text"
}
const _hoisted_29 = {
  key: 1,
  class: "frisbuy-marketplace-reviews__pagination"
}
const _hoisted_30 = {
  key: 1,
  class: "frisbuy-marketplace-reviews__mobile-iu",
  "widget-iu-button": "true",
  onclick: "iuWidget.open()"
}

import {
  computed,
  nextTick,
  onBeforeUnmount,
  ref,
  watch,
  onMounted,
  onBeforeMount,
} from "vue";
// Components
import CustomerReview from "./components/CustomerReview.vue";
import CustomersPhotosSkeleton from "./components/CustomersPhotosSkeleton.vue";
import LoadMoreButton from "./components/LoadMoreButton/LoadMoreButton.vue";
import MediaList from "./components/MediaList.vue";
import RatingBar from "./components/RatingBar/RatingBar.vue";
import FrSelect from "./components/FrSelect/FrSelect.vue";
import FrSegmented from "./components/FrSegmented/FrSegmented.vue";
// Services
import { getPostsInfo, TPostsFilterOptions } from "../../api/api";
// Icons
import StarRounded from "./Icons/StarRounded.vue";
// Types
import {
  imageWithPostId,
  IMarketplaceReviewsPost,
  productRating,
} from "./interfaces";
import { TRating } from "./interfaces";
// Hooks
import usePostExtractor from "./hooks/postExtractor";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentWrapper',
  props: {
    settings: {},
    propPostList: {},
    lastPage: {},
    propPostCount: {},
    allCustomersMediaList: {},
    customersMediaTotalCount: {},
    isLoadingCustomersMedia: { type: Boolean },
    isShowFullyWidgetLoading: { type: Boolean },
    productRating: {},
    isFullyWidget: { type: Boolean },
    isMobileScreenSize: { type: Boolean },
    extraData: {}
  },
  emits: [
  "selectPost",
  "sendAnaliticEvent",
  "showFullyWidget",
  "changeMediaSort",
  "mergeMediaFromPosts",
],
  setup(__props: any, { emit: __emit }) {

// Modules
const postExtractor = usePostExtractor();

const props = __props;
const emit = __emit;

const hadSeen = ref(false);
const inViewTimeout = ref<number | undefined>(undefined);
const had5SecInView = ref(false);

const postList = ref<IMarketplaceReviewsPost[]>(props.propPostList);

onBeforeMount(() => {
  updateCountOfPages();
});

const countOfPages = ref(0);
const isLastPageByRequest = ref(Boolean(props.lastPage));

const isLastPage = computed(() => {
  return isLastPageByRequest.value || selectedPage.value === countOfPages.value;
});

const showedPostList = computed(() => {
  if (props.isFullyWidget) {
    return postList.value;
  }

  return postList.value.slice(0, 3);
});

function selectPage(page: number) {
  selectedPage.value = page;

  emit(
    "sendAnaliticEvent",
    "NextPage",
    ++page,
    props.settings.analytics.sendNextPageToClient
  );

  updatePostList();
}

function updateCountOfPages() {
  countOfPages.value = Math.ceil(postCount.value / perPage);
}

// Product rating
const divisionByRating = computed<TRating[] | []>(() => {
  if (!props.productRating) {
    console.error("productRating not defined");

    return [];
  }

  const productRating: Array<TRating> = Object.values(
    props.productRating.divisionByRating
  ).map((value, index) => {
    return {
      label: String(index + 1),
      count: Number(value),
    };
  });

  return productRating.reverse();
});

const isSoftStarIcon = computed(() => {
  return props.settings.gallery.starIconType === "1";
});

const isHasSummary = computed(() => {
  if (!props.productRating) return false;

  return props.productRating.summary;
});

function isElementInView(element: any, isFull = false) {
  if (!element) return;

  const { top, bottom, height } = element.getBoundingClientRect();
  const { innerHeight: windowHeight } = window;

  if (isFull) {
    return (
      (height > windowHeight && bottom > 0 && bottom < windowHeight) ||
      (top > 0 && bottom < windowHeight)
    );
  } else {
    return top < windowHeight;
  }
}

function scrollHandler() {
  const InView5SecHandler = () => {
    had5SecInView.value = true;
    emit("sendAnaliticEvent", "Eyesight5Sec", window.location.href, true, true);
  };

  nextTick(() => {
    const firstItem = widgetMarketplaceReviews.value?.querySelector(
      ".frisbuy-marketplace-reviews__list-item"
    );
    if (
      !had5SecInView.value &&
      isElementInView(widgetMarketplaceReviews.value, true)
    ) {
      window.clearTimeout(inViewTimeout.value);

      inViewTimeout.value = setTimeout(InView5SecHandler, 5000);
    } else {
      window.clearTimeout(inViewTimeout.value);
    }

    if (
      !hadSeen.value &&
      isElementInView(firstItem || widgetMarketplaceReviews.value, true)
    ) {
      hadSeen.value = true;
      emit("sendAnaliticEvent", "Eyesight", window.location.href, true, true);
    }
  });
}

function getPluralizatedRatingCount() {
  if (!props.productRating) {
    return "";
  }

  const lastTwo = Math.abs(props.productRating.reviewsCount) % 100;
  const lastOne = Math.abs(props.productRating.reviewsCount) % 10;

  if (lastTwo >= 11 && lastTwo <= 14) {
    return "оценок";
  }

  if (lastOne === 1) {
    return "оценка";
  }

  if (lastOne >= 2 && lastOne <= 4) {
    return "оценки";
  }

  return "оценок";
}

function getMediaIndexInPost(media: imageWithPostId): number | undefined {
  const mediaOfPost = allCustomersMediaList.value.filter(
    (item) => item.postId === media.postId
  );
  if (!mediaOfPost.length) {
    return undefined;
  }

  const byRefIndex = mediaOfPost.findIndex((item) => item === media);
  if (byRefIndex >= 0) {
    return byRefIndex;
  }

  const byUrlIndex = mediaOfPost.findIndex((item) => {
    return (
      (item.thumbnailUrl && item.thumbnailUrl === media.thumbnailUrl) ||
      (item.imageHighResolutionUrl &&
        item.imageHighResolutionUrl === media.imageHighResolutionUrl) ||
      (item.imageUrl && item.imageUrl === media.imageUrl) ||
      (item.videoUrl && item.videoUrl === media.videoUrl)
    );
  });

  return byUrlIndex >= 0 ? byUrlIndex : undefined;
}

// Customers photo
const allCustomersMediaList = computed<Array<imageWithPostId>>(() => {
  return props.allCustomersMediaList ?? [];
});
const customersMediaTotalCount = computed<number | null>(() => {
  return props.customersMediaTotalCount ?? null;
});

const isNoMediaLoadingState = computed(() => {
  return Boolean(
    !props.isLoadingCustomersMedia && allCustomersMediaList.value.length === 0
  );
});

onMounted(() => {
  scrollHandler();
  window.addEventListener("scroll", scrollHandler);
  nextTick(() => {
    setupMobileLoadMoreObserver();
  });

  const { embedId, widgetStart } = props.settings;
  const entries = (performance && performance.getEntries()) || null;
  const times: any = {};

  if (entries) {
    if (widgetStart) {
      times.domInject = (performance.now() - widgetStart).toFixed(2);
    }

    entries.forEach((entry) => {
      if (entry.name.includes(embedId)) {
        times.queued = entry.startTime.toFixed(2);
        times.load = entry.duration.toFixed(2);
      } else if (
        entry.name.includes("www.frisbuy.ru") &&
        entry.name.includes("compiled")
      ) {
        times.bundle = entry.duration.toFixed(2);
      }
    });

    emit("sendAnaliticEvent", "TimeLoad", times, false, true);
  }

  emit("sendAnaliticEvent", "Load", window.location.href, true, true);

  if (props.settings.gallery.elasticFilter) {
    emit(
      "sendAnaliticEvent",
      "FilterElastic",
      window.location.href,
      true,
      true
    );
  }
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", scrollHandler);
  mobileLoadMoreObserver?.disconnect();
  mobileLoadMoreObserver = null;
});

// Pagination and filters
const postCount = ref(props.propPostCount);
const perPage = postList.value.length;

const selectedPage = ref(1);

const widgetMarketplaceReviews = ref<HTMLElement | null>(null);
const mobileLoadMoreSentinel = ref<HTMLElement | null>(null);
let mobileLoadMoreObserver: IntersectionObserver | null = null;

const filterSegment = ref();
const filterSort = ref();
const filterRating = ref();
const mediaFilterValue = ref<"1" | undefined>(undefined);
const isMediaFilterEnabled = computed(() => mediaFilterValue.value === "1");
const isFiltersDisabled = computed(
  () => isLoadPosts.value || Boolean(props.isLoadingCustomersMedia)
);
const isMediaFilterVisible = computed(() => {
  if (props.isLoadingCustomersMedia) {
    return true;
  }

  if ((customersMediaTotalCount.value ?? 0) > 0) {
    return true;
  }

  return allCustomersMediaList.value.length > 0;
});

// NOTE: if need clear postLIst on filter update
watch(filterRating, () => {
  postList.value = [];
});

watch([filterSegment], async () => {
  selectedPage.value = 1;

  updatePostList(undefined, true);

  if (!props.isFullyWidget) {
    return;
  }

  const selectedOrderBy = filterSort.value?.value || "provider_created";
  const selectedSort = filterSort.value?.sort || "desc";
  const currentVariant = filterSegment.value?.value;

  emit(
    "changeMediaSort",
    selectedOrderBy,
    selectedSort,
    currentVariant === "true" ? "true" : undefined
  );
});

watch(
  [filterRating, filterSort],
  async (
    [newFilterRating, newFilterSort],
    [oldFilterRating, oldFilterSort]
  ) => {
    const isRatingChanged = newFilterRating?.value !== oldFilterRating?.value;
    const isSortChanged =
      newFilterSort?.value !== oldFilterSort?.value ||
      newFilterSort?.sort !== oldFilterSort?.sort;

    if (isRatingChanged || isSortChanged) {
      selectedPage.value = 1;
      updatePostList(undefined, true);
      return;
    }

    updatePostList();
  }
);

watch(mediaFilterValue, () => {
  selectedPage.value = 1;
  updatePostList(undefined, true);
});

watch(filterSort, (newFilterSort, oldFilterSort) => {
  if (!props.isFullyWidget || !newFilterSort) {
    return;
  }

  if (
    oldFilterSort &&
    newFilterSort.value === oldFilterSort.value &&
    newFilterSort.sort === oldFilterSort.sort
  ) {
    return;
  }

  emit(
    "changeMediaSort",
    newFilterSort.value,
    newFilterSort.sort || "desc",
    filterSegment.value?.value === "true" ? "true" : undefined
  );
});

const isLoadPosts = ref(false);

function toggleMediaFilter() {
  mediaFilterValue.value = mediaFilterValue.value === "1" ? undefined : "1";
}

function loadNextPageOnMobileScroll() {
  if (!props.isFullyWidget || !props.isMobileScreenSize) {
    return;
  }

  if (isLoadPosts.value || isLastPage.value) {
    return;
  }

  selectPage(selectedPage.value + 1);
}

function setupMobileLoadMoreObserver() {
  mobileLoadMoreObserver?.disconnect();
  mobileLoadMoreObserver = null;

  if (
    typeof window === "undefined" ||
    !("IntersectionObserver" in window) ||
    !props.isFullyWidget ||
    !props.isMobileScreenSize ||
    !mobileLoadMoreSentinel.value
  ) {
    return;
  }

  mobileLoadMoreObserver = new IntersectionObserver(
    (entries) => {
      if (!entries[0]?.isIntersecting) {
        return;
      }

      loadNextPageOnMobileScroll();
    },
    {
      root: null,
      threshold: 0.1,
    }
  );

  mobileLoadMoreObserver.observe(mobileLoadMoreSentinel.value);
}

async function updatePostList(
  page: number | undefined = undefined,
  isForceUpdate: boolean = false
) {
  const { embedId, skuId, groupId, srcDomain } = props.settings;
  const apiDefaults = { embedId, skuId, groupId, srcDomain };

  const pageForLoad = page || selectedPage.value;

  const selectedOrderBy = filterSort.value?.value;
  const selectedSort = filterSort.value?.sort;

  const filterOptions: TPostsFilterOptions = {
    page: pageForLoad,
    orgerBy: selectedOrderBy === "rating" ? "rating" : "provider_created",
    sort: selectedSort || "desc",
    ratingFilter: filterRating.value?.value,
    current_variant: filterSegment.value?.value,
    media_filter: mediaFilterValue.value,
  };

  isLoadPosts.value = true;

  try {
    // TODO: add request's error handler
    const postsInfo = await getPostsInfo(apiDefaults, filterOptions);
    const newPosts = postsInfo.posts;

    if (typeof postsInfo?.lastPage === "boolean") {
      isLastPageByRequest.value = postsInfo.lastPage;
    } else {
      isLastPageByRequest.value = selectedPage.value === countOfPages.value;
    }

    if (props.isFullyWidget) {
      emit("mergeMediaFromPosts", newPosts);
    }

    if (isForceUpdate) {
      postList.value = newPosts;
    }

    const pageIndex = perPage * (pageForLoad - 1);
    newPosts?.forEach((post: IMarketplaceReviewsPost, idx: number) => {
      postList.value[pageIndex + idx] = post;
    });

    postCount.value = postsInfo.postCount;
  } finally {
    isLoadPosts.value = false;
  }
}

watch(
  [
    () => props.isMobileScreenSize,
    () => props.isFullyWidget,
    () => postList.value.length,
    () => isLastPage.value,
  ],
  async () => {
    await nextTick();
    setupMobileLoadMoreObserver();
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.settings.gallery.header.html)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          innerHTML: props.settings.gallery.header.html
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      ref_key: "widgetMarketplaceReviews",
      ref: widgetMarketplaceReviews,
      class: _normalizeClass(["frisbuy-marketplace-reviews", { 'frisbuy-marketplace-reviews--fully': props.isFullyWidget }])
    }, [
      (props.productRating)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  (props.productRating?.avgRating)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("span", null, _toDisplayString(props.productRating.avgRating.toFixed(1)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(props.productRating.reviewsCount) + " " + _toDisplayString(getPluralizatedRatingCount()), 1)
                ]),
                _createVNode(RatingBar, {
                  divisionByRating: divisionByRating.value,
                  isSoftStarIcon: isSoftStarIcon.value
                }, null, 8, ["divisionByRating", "isSoftStarIcon"])
              ]),
              _createElementVNode("button", {
                class: _normalizeClass(["frisbuy-image-upload-button", { 'frisbuy-image-upload-button--fully': _ctx.isFullyWidget }]),
                "widget-iu-button": "true",
                onclick: "iuWidget.open()"
              }, _hoisted_9, 2),
              (!_ctx.isFullyWidget)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "frisbuy-image-all-reviews-button",
                    disabled: props.isShowFullyWidgetLoading,
                    "aria-busy": props.isShowFullyWidgetLoading ? 'true' : 'false',
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('showFullyWidget')))
                  }, [
                    (props.isShowFullyWidgetLoading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, " Все отзывы " + _toDisplayString(props.productRating.allReviewsCount), 1)
                  ], 8, _hoisted_10))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("h3", {
            class: _normalizeClass(["frisbuy-marketplace-reviews__customers-photos-title", {
            'frisbuy-marketplace-reviews__customers-photos-title--mobile':
              props.isMobileScreenSize,
          }])
          }, " Отзывы и рейтинг ", 2),
          _createElementVNode("div", {
            class: _normalizeClass(["frisbuy-marketplace-reviews__mobile-rating", {
            'frisbuy-marketplace-reviews__mobile-rating--mobile':
              props.isMobileScreenSize,
          }])
          }, [
            _createVNode(StarRounded, { width: "32px" }),
            _createElementVNode("span", _hoisted_14, [
              _createTextVNode(_toDisplayString(props.productRating?.avgRating.toFixed(1)) + " ", 1),
              _createElementVNode("div", _hoisted_15, "  / " + _toDisplayString(props.productRating?.reviewsCount) + " " + _toDisplayString(getPluralizatedRatingCount()), 1)
            ])
          ], 2),
          (
            props.isLoadingCustomersMedia || allCustomersMediaList.value.length > 0
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  (props.isLoadingCustomersMedia)
                    ? (_openBlock(), _createBlock(CustomersPhotosSkeleton, {
                        key: 0,
                        isMobile: Boolean(props.isMobileScreenSize),
                        itemsCount: props.isMobileScreenSize ? 4 : 6
                      }, null, 8, ["isMobile", "itemsCount"]))
                    : (allCustomersMediaList.value.length > 0)
                      ? (_openBlock(), _createBlock(MediaList, {
                          key: 1,
                          mediaWidth: 
                props.isMobileScreenSize
                  ? `calc(25% - ${(3 * 8) / 4}px)`
                  : '80px'
              ,
                          mediaList: allCustomersMediaList.value,
                          totalMediaCount: customersMediaTotalCount.value ?? undefined,
                          maxMediaItems: _ctx.isMobileScreenSize ? 4 : 6,
                          isShowCountHover: "",
                          onSelectMedia: _cache[1] || (_cache[1] = 
                (media) =>
                  emit(
                    'selectPost',
                    media.postId,
                    media,
                    undefined,
                    getMediaIndexInPost(media)
                  )
              )
                        }, null, 8, ["mediaWidth", "mediaList", "totalMediaCount", "maxMediaItems"]))
                      : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (isHasSummary.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("span", {
                class: "frisbuy-marketplace-reviews__summary-text",
                innerHTML: props.productRating?.summary?.text || ''
              }, null, 8, _hoisted_20)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_21, [
          (props.isFullyWidget)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["frisbuy-marketplace-reviews__filters", {
            'frisbuy-marketplace-reviews__filters--no-media-loading':
              isNoMediaLoadingState.value,
          }])
              }, [
                (props.extraData?.currentVariantPostsCount)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createVNode(FrSegmented, {
                        modelValue: filterSegment.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filterSegment).value = $event)),
                        class: "frisbuy-marketplace-reviews__segmented-list",
                        disabled: isFiltersDisabled.value,
                        options: [
                { label: 'Все отзывы', value: 'false' },
                { label: `Этот вариант`, value: 'true' },
              ],
                        defaultOption: { label: 'Все отзывы', value: 'false' }
                      }, null, 8, ["modelValue", "disabled"])
                    ]))
                  : _createCommentVNode("", true),
                (isMediaFilterVisible.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["frisbuy-marketplace-reviews__media-filter-button", {
                'frisbuy-marketplace-reviews__media-filter-button--active':
                  isMediaFilterEnabled.value,
              }]),
                        disabled: isFiltersDisabled.value,
                        onClick: toggleMediaFilter
                      }, " С фото/видео ", 10, _hoisted_24)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(FrSelect, {
                    modelValue: filterSort.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filterSort).value = $event)),
                    disabled: isFiltersDisabled.value,
                    options: [
                {
                  value: 'provider_created',
                  sort: 'desc',
                  text: 'Сначала новые',
                },
                {
                  value: 'rating',
                  sort: 'desc',
                  text: 'Сначала с высокой оценкой',
                },
                {
                  value: 'rating',
                  sort: 'asc',
                  text: 'Сначала с низкой оценкой',
                },
              ],
                    defaultOption: {
                value: 'provider_created',
                sort: 'desc',
                text: 'Сначала новые',
              }
                  }, null, 8, ["modelValue", "disabled"])
                ])
              ], 2))
            : _createCommentVNode("", true),
          (postList.value.length)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_26, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showedPostList.value, (post, postIndex) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: postIndex }, [
                    post
                      ? (_openBlock(), _createElementBlock("li", {
                          key: 0,
                          class: "frisbuy-marketplace-reviews__list-item",
                          onClick: 
                () =>
                  emit(
                    'selectPost',
                    post.instagramPost.frisbuyId,
                    undefined,
                    post
                  )
              
                        }, [
                          _createVNode(CustomerReview, {
                            customerName: 
                  post.instagramPost.authorUser.fio ||
                  `@${post.instagramPost.authorUser.username}`
                ,
                            reviewDate: _unref(postExtractor).getParsedReviewDate(post),
                            rating: post.frisbuyPost.rating,
                            mediaList: post.media,
                            isShowMedia: post.instagramPost.hasMedia,
                            negativeComment: post.frisbuyPost.negativeComment,
                            positiveComment: post.frisbuyPost.positiveComment,
                            text: post.frisbuyPost.text,
                            isSoftStarIcon: isSoftStarIcon.value,
                            onSelectReview: 
                  () =>
                    emit(
                      'selectPost',
                      post.instagramPost.frisbuyId,
                      undefined,
                      post
                    )
                ,
                            onSelectMedia: 
                  (media) =>
                    emit('selectPost', post.instagramPost.frisbuyId, media, post)
                
                          }, null, 8, ["customerName", "reviewDate", "rating", "mediaList", "isShowMedia", "negativeComment", "positiveComment", "text", "isSoftStarIcon", "onSelectReview", "onSelectMedia"])
                        ], 8, _hoisted_27))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_28, " Отзывы по выбранным фильтрам не найдены "))
        ]),
        (
          countOfPages.value > 0 &&
          _ctx.isFullyWidget &&
          postList.value.length > 0 &&
          !isLastPage.value
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createVNode(LoadMoreButton, {
                countOfPages: countOfPages.value,
                selectedPage: selectedPage.value,
                isLoadPosts: isLoadPosts.value,
                onSelectPage: _cache[4] || (_cache[4] = (page) => selectPage(page))
              }, null, 8, ["countOfPages", "selectedPage", "isLoadPosts"])
            ]))
          : _createCommentVNode("", true),
        (
          countOfPages.value > 0 &&
          _ctx.isFullyWidget &&
          _ctx.isMobileScreenSize &&
          postList.value.length > 0 &&
          !isLastPage.value
        )
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              ref_key: "mobileLoadMoreSentinel",
              ref: mobileLoadMoreSentinel,
              class: "frisbuy-marketplace-reviews__mobile-loadmore-sentinel"
            }, null, 512))
          : _createCommentVNode("", true)
      ]),
      (_ctx.isFullyWidget)
        ? (_openBlock(), _createElementBlock("button", _hoisted_30, " Оставить отзыв "))
        : _createCommentVNode("", true)
    ], 2)
  ], 64))
}
}

})